import { Link, NavLink } from 'react-router-dom'

export function SiteHeader() {
  return (
    <header className="site-header">
      <Link to="/" className="wordmark" aria-label="Japan 2026 home">
        <span className="wordmark-mark" aria-hidden="true">日</span>
        <span>Japan <i>’26</i></span>
      </Link>
      <nav aria-label="Primary navigation">
        <NavLink to="/" end>Journey</NavLink>
        <NavLink to="/wallet">Travel wallet</NavLink>
      </nav>
    </header>
  )
}
